export default __webpack_public_path__ + "static/media/red-cross-late.ed502382.svg";